import React, { useState, useEffect } from 'react';
import './InvestorsList.css';
import Topheader from '../component/Topheader';
import EditInvestorDialog from './EditInvestorDialog';
import API_URL from '../config';

const InvestorsList = () => {
    const [investors, setInvestors] = useState([]);
    const [activeTab, setActiveTab] = useState('angel');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [selectedInvestor, setSelectedInvestor] = useState(null);

    useEffect(() => {
        fetchInvestors();
    }, [activeTab]);

    const fetchInvestors = async () => {
        try {
            const response = await fetch(`${API_URL}/api/investors/${activeTab}`);
            const data = await response.json();
            setInvestors(data.data || []);
            setLoading(false);
        } catch (err) {
            setError('Failed to fetch investors');
            setLoading(false);
        }
    };

    const handleDelete = async (investorId) => {
        if (window.confirm('Are you sure you want to delete this investor?')) {
            try {
                const response = await fetch(`${API_URL}/api/investors/${investorId}`, { method: 'DELETE' });
    
                if (!response.ok) {
                    const contentType = response.headers.get("content-type");
                    let errorMessage = 'Failed to delete investor';
    
                    if (contentType && contentType.includes("application/json")) {
                        const errorData = await response.json();
                        errorMessage = errorData.error || errorMessage;
                    } else {
                        errorMessage = await response.text(); // Get the HTML error message
                    }
    
                    throw new Error(errorMessage);
                }
    
                setInvestors(investors.filter(inv => inv._id !== investorId));
    
            } catch (err) {
                console.error("Delete error:", err);
                alert(err.message);
            }
        }
    };

    const handleEdit = (investor) => {
        setSelectedInvestor(investor);
        setEditDialogOpen(true);
    };

    const handleSaveEdit = (updatedInvestor) => {
        setInvestors(investors.map(inv =>
            inv._id === updatedInvestor._id ? { ...inv, ...updatedInvestor } : inv
        ));
    };

    const handleSaveInvestor = (updatedInvestor) => {
        setInvestors(prevInvestors =>
            prevInvestors.map(inv =>
                inv._id === updatedInvestor._id ? updatedInvestor : inv
            )
        );
    };

    if (loading) {
        return (
            <div className="loading-container">
                <div className="loading-spinner"></div>
                <p>Loading investors...</p>
            </div>
        );
    }

    if (error) {
        return <div className="error-message">{error}</div>;
    }

    return (
        <div>
            <div className="investors-container">
                    <div className="header">
                        <h1>Investors List</h1>
                        <button
                            onClick={() => window.location.href = '/addinvestor'}
                            className="add-button"
                        >
                            Add New Investor
                        </button>
                    </div>

                    <div className="tabs">
                        <button
                            className={`tab-button ${activeTab === 'angel' ? 'active' : ''}`}
                            onClick={() => setActiveTab('angel')}
                        >
                            Angel Investors
                        </button>
                        <button
                            className={`tab-button ${activeTab === 'vc' ? 'active' : ''}`}
                            onClick={() => setActiveTab('vc')}
                        >
                            VC Investors
                        </button>
                    </div>

                    <div className="table-wrapper">
                        <table className="investors-table">
                            <thead>
                                <tr>
                                    {activeTab === 'vc' && <th>Logo</th>}
                                    <th>{activeTab === 'angel' ? 'Investor Name' : 'Firm Name'}</th>
                                    <th>LinkedIn</th>
                                    <th>Email</th>
                                    <th>Contact</th>
                                    <th>Stage</th>
                                    <th>Industry</th>
                                    <th>Skills</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {investors.map((investor) => (
                                    <tr key={investor._id}>
                                        {activeTab === 'vc' && (
                                            <td>
                                                <img
                                                    src={`${API_URL}/${investor.firmLogo}`}
                                                    className="firm-logo"
                                                />
                                            </td>
                                        )}
                                        <td className="investor-name">
                                            {activeTab === 'angel' ? investor.investorName : investor.firmName}
                                        </td>
                                        <td>
                                            <a
                                                href={investor.linkedinProfile}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="linkedin-link"
                                            >
                                                Profile
                                            </a>
                                        </td>
                                        <td>{investor.email}</td>
                                        <td>{investor.contactNumber}</td>
                                        <td>{investor.stage}</td>
                                        <td>{investor.industry}</td>
                                        <td>
                                            <div className="skills-container">
                                                {investor.skills.map((skill, index) => (
                                                    <span key={index} className="skill-tag">
                                                        {skill}
                                                    </span>
                                                ))}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="action-buttons">
                                                <button
                                                    onClick={() => handleEdit(investor)}
                                                    className="edit-button"
                                                >
                                                    Edit
                                                </button>
                                                <button
                                                    onClick={() => handleDelete(investor._id)}
                                                    className="delete-button"
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                {selectedInvestor && (
                    <EditInvestorDialog
                        investor={selectedInvestor}
                        isOpen={editDialogOpen}
                        onClose={() => {
                            setEditDialogOpen(false);
                            setSelectedInvestor(null);
                        }}
                        onSave={handleSaveInvestor}
                        investorType={activeTab}
                    />
                )}
        </div>
    );
};

export default InvestorsList;